// extracted by mini-css-extract-plugin
export var actionButton = "_cw-0";
export var attachmentLine = "_cw-1";
export var fileInput = "_cw-2";
export var fileUploadWrapper = "_cw-4";
export var footer = "_cw-3";
export var modalContent = "_cw-5";
export var paperclip = "_cw-6";
export var quillEditor = "_cw-7";